import { feature as obsessionServiceFeature } from '@central-products/obsession-service';

export const obsessionServicePlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(obsessionServiceFeature);
  },
};
